import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../core/base.service';
import { OperationRegisterService } from '../core/operation-register.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentCaptureTokenHttpService {
  constructor(
    private http: HttpClient,
    private base: BaseService,
    private ro: OperationRegisterService
  ) {}

  getTokens() {
    const url = `${this.base.getPrivateOIMBaseUrl()}/documentCapture/tokens`;
    const headers = this.base.getPrivateOIMHeaders();
    const origin = this.ro.getOrigin();
    const body = { roData: { origin } };
    return this.http.post<{ documentNumber: string; accessToken: string }[]>(
      url,
      body,
      headers
    );
  }
}
